module.exports = __webpack_public_path__ + "img/profile_box_foot_way.550a1ded.svg";